import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

// Colores corporativos
const COLORS = ['#004aad', '#002557', '#cb9f46', '#a9acb5'];

const InvestmentDistributionChart = ({ portfolioInvestments }) => {
  // Filtrar solo los portfolios con inversión > 0
  const data = portfolioInvestments
    .filter(p => p.investmentAmount > 0)
    .map(p => ({
      name: p.name,
      value: p.investmentAmount
    }));

  // Si no hay inversiones, mostrar un mensaje
  if (data.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-500 text-sm">
        Ingresa montos de inversión para ver la distribución
      </div>
    );
  }

  // Calcular el total para los porcentajes
  const total = data.reduce((sum, item) => sum + item.value, 0);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const percentage = ((data.value / total) * 100).toFixed(1);
      return (
        <div className="bg-white p-2 border border-gray-200 rounded shadow-sm">
          <p className="font-medium text-sm text-[#0c1230]">{data.name}</p>
          <p className="text-sm text-[#002557]">
            ${data.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <p className="text-sm text-[#cb9f46]">{percentage}%</p>
        </div>
      );
    }
    return null;
  };

  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <ul className="flex flex-col gap-1">
        {payload.map((entry, index) => (
          <li key={`item-${index}`} className="flex items-center gap-2 text-sm">
            <span className="w-3 h-3 rounded-sm" style={{ backgroundColor: entry.color }} />
            <span className="text-[#0c1230]">{entry.value}</span>
            <span className="text-[#002557]">
              ({((data[index].value / total) * 100).toFixed(1)}%)
            </span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="h-full flex items-center">
      <div className="flex items-center gap-8">
        <div className="w-[200px] h-[200px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="py-4">
          <Legend content={renderLegend} />
        </div>
      </div>
    </div>
  );
};

export default InvestmentDistributionChart; 